import React, { useState } from 'react';
import { Box, Text, Menu, MenuButton, MenuList, MenuItem, Button } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { getCityLabel, getCountryLabel } from '../utils';

interface LocationSelectorProps {
  selectedCountry: string;
  selectedCity: string;
  onCountryChange: (country: string) => void;
  onCityChange: (city: string) => void;
  showCountryTitle?: boolean;
  showCityTitle?: boolean;
}

const LocationSelector: React.FC<LocationSelectorProps> = ({
  selectedCountry,
  selectedCity,
  onCountryChange,
  onCityChange,
  showCountryTitle = true,
  showCityTitle = true
}) => {
  const [isCountryMenuOpen, setIsCountryMenuOpen] = useState(false);
  const [isCityMenuOpen, setIsCityMenuOpen] = useState(false);
  const getCityOptions = () => {
    const cityMap: { [key: string]: string[] } = {
      latvia: ['riga', 'daugavpils', 'liepaja', 'jelgava'],
      estonia: ['tallinn', 'tartu', 'narva', 'parnu'],
      lithuania: ['vilnius', 'kaunas', 'klaipeda', 'siauliai'],
      finland: ['helsinki', 'espoo', 'tampere', 'vantaa'],
      sweden: ['stockholm', 'gothenburg', 'malmo', 'uppsala'],
      norway: ['oslo', 'bergen', 'trondheim', 'stavanger'],
      denmark: ['copenhagen', 'aarhus', 'odense', 'aalborg'],
      germany: ['berlin', 'hamburg', 'munich', 'cologne'],
      poland: ['warsaw', 'krakow', 'gdansk', 'wroclaw'],
      france: ['paris', 'marseille', 'lyon', 'toulouse'],
      spain: ['madrid', 'barcelona', 'valencia', 'seville'],
      italy: ['rome', 'milan', 'naples', 'turin'],
      united_kingdom: ['london', 'birmingham', 'manchester', 'glasgow'],
      united_states: ['new_york', 'los_angeles', 'chicago', 'houston'],
      canada: ['toronto', 'montreal', 'vancouver', 'calgary']
    };
    return cityMap[selectedCountry] || [];
  };


  const countries = [
    'latvia', 'estonia', 'lithuania', 'finland', 'sweden', 'norway', 'denmark',
    'germany', 'poland', 'france', 'spain', 'italy', 'united_kingdom',
    'united_states', 'canada'
  ];

  return (
    <>
      {/* Country */}
      <Box marginBottom="18px" width="297px" position="relative">
        {showCountryTitle && (
          <Text 
            className="static-text-white"
            marginBottom="16px"            
          >
            Country
          </Text>
        )}
        <Menu 
          isOpen={isCountryMenuOpen} 
          onOpen={() => setIsCountryMenuOpen(true)} 
          onClose={() => setIsCountryMenuOpen(false)}
        >
          <MenuButton
            as={Button}
            className="menu-button"            
            rightIcon={<ChevronDownIcon color="#FFFFFF" boxSize="12px" />}
          >            
              {selectedCountry ? getCountryLabel(selectedCountry) : (showCountryTitle ? "None" : "Country")}
          </MenuButton>
          <MenuList className="menu-list" >
            {countries.map((countryValue) => (
              <MenuItem
                key={countryValue}
                className="menu-item"                
                onClick={() => onCountryChange(countryValue)}
              >
                {getCountryLabel(countryValue)}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      </Box>

      {/* City */}
      <Box width="297px" position="relative">
        {showCityTitle && (
          <Text 
            className="static-text-white"
            marginBottom="16px"
          >
            City
          </Text>
        )}
        <Menu 
          isOpen={isCityMenuOpen} 
          onOpen={() => setIsCityMenuOpen(true)} 
          onClose={() => setIsCityMenuOpen(false)}
        >
          <MenuButton
            as={Button}
            className="menu-button"            
            rightIcon={<ChevronDownIcon color="#FFFFFF" boxSize="12px" />}
            isDisabled={!selectedCountry}
          >
              {selectedCity ? getCityLabel(selectedCity) : (showCityTitle ? "None" : "City")}
          </MenuButton>
          <MenuList className="menu-list" >
            {getCityOptions().map((cityValue) => (
              <MenuItem
                key={cityValue}
                className="menu-item"                
                onClick={() => onCityChange(cityValue)}
              >
                {getCityLabel(cityValue)}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      </Box>
    </>
  );
};

export default LocationSelector;
